import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { GiftToneResponse } from '../../../../core/api/tune/gifttune/gifttoneresponse';
import { GiftToneRequestImpl } from '../../../../core/api/tune/gifttune/gifttonerequest';
import { GiftToneDto } from '../../../../core/dto/gifttone/gifttonedto';
import { ToneDto } from '../../../../core/dto/tonedto';
import { GetTonePriceDtoImpl } from '../../../../core/dto/gettoneprice/gettonepricedto';
import { GetTonePriceResponse } from '../../../../core/api/tune/gettuneprice/gettonepriceresponse';
import { GetTonePriceRequestImpl } from '../../../../core/api/tune/gettuneprice/gettonepricerequest';
import { ToneProcessorFactory } from '../../../../core/processorfactory/toneprocessorfactory';
import { SubscriberValidationDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/subscribervalidation/subscribervalidationdto';
import { SubscriberValidationResponse } from 'src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationresponse';
import { SubscriberValidationRequestImpl } from 'src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationrequest';


export interface GiftAFriendAPIModel extends APIModel 
{
    giftAFriend(giftAFriendDto: GiftToneDto): void;
    getTonePrice(toneDto: ToneDto, msisdnB: string): void;
    validateNumber(toneDto: ToneDto, giftDto:GiftToneDto):void;
}

export class GiftAFriendAPIModelImpl extends APIModelImpl implements GiftAFriendAPIModel 
{
    private toneProcessor: ToneProcessorFactory;
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler) 
    {
        super(applicationContext, apiModelHandler);
        this.toneProcessor = this.getAPIProcesssorFactory().getToneProcessorFactory();
    }

    giftAFriend(tellAFriendDto: GiftToneDto): void 
    {
        this.toneProcessor.getGiftToneDetails()
        .success((buyResponse : GiftToneResponse)=>
         {
            this.getAPIModelHandler().onSuccess(buyResponse.getAPIFeature(), 
            buyResponse.getDescription(), buyResponse);
         })
       .failure((buyResponse : GiftToneResponse)=>
       {
           this.getAPIModelHandler().onFailure(buyResponse.getAPIFeature(), 
           buyResponse.getDescription(), buyResponse);
         })
       .execute(new GiftToneRequestImpl(tellAFriendDto));
    }

    validateNumber(toneDto: ToneDto, giftDto:GiftToneDto):void
    {
      let subscriberValidationDto = new SubscriberValidationDtoImpl();
      subscriberValidationDto.setMsisdn(giftDto.getMsisdnB());
      subscriberValidationDto.setLanguage(this.getContext().getUserContext().getLanguage());

      this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().validateSubscriber()
          .success(() => {
              this.getTonePrice(toneDto, giftDto.getMsisdnB());
          })
          .failure((subscriberValidationResponse: SubscriberValidationResponse) => {
              this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
                  subscriberValidationResponse.getDescription(), subscriberValidationResponse);
          })
          .execute(new SubscriberValidationRequestImpl(subscriberValidationDto));
    }
    getTonePrice(toneDto: ToneDto, msisdnB: string): void 
    {
        let getTonePriceDto =  new GetTonePriceDtoImpl();
        getTonePriceDto.setLanguage(this.getContext().getUserContext().getLanguage());
        getTonePriceDto.setServiceId("1");
        getTonePriceDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        getTonePriceDto.setBPartyMsisdnList('[{"bPartyMsisdn":' + 
       '"'+ msisdnB+ '"}]');
        getTonePriceDto.setToneId(toneDto.getId());
        getTonePriceDto.setValidationIdentifier("2");
        getTonePriceDto.setChannelId(this.getContext().getUserContext().getChannelId());

        this.toneProcessor.getGetTonePriceAPIProcessor()
        .success((getTonePriceResponse : GetTonePriceResponse)=>
         {
            this.getAPIModelHandler().onSuccess(getTonePriceResponse.getAPIFeature(), 
            msisdnB, getTonePriceResponse.getGetTonePriceDto().getToneDetailsList()[0]);
            console.log("gift *******",JSON.stringify(getTonePriceResponse.getGetTonePriceDto()));
         })
       .failure((getTonePriceResponse : GetTonePriceResponse)=>
       {
           this.getAPIModelHandler().onFailure(getTonePriceResponse.getAPIFeature(), 
           getTonePriceResponse.getDescription(), getTonePriceResponse);
         })
       .execute(new GetTonePriceRequestImpl(getTonePriceDto));
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/giftafriend/giftafriendapimodel.tsx